import { Typography } from "@material-ui/core";
import React from "react";

export type SectionTitleProps = {
    id?: string,
    name?: string,
    text: string,
    className?: string,
    style?: React.CSSProperties,
    primary?: boolean,
    variant?: string
}

export function SectionTitle(props: SectionTitleProps) {
    return (
        <Typography
            {...props}
            id={props.id}
            align={props.primary !== undefined && props.primary ? "center" : "left"}
            variant={"h4"}
            style={{ ...props.style, marginBottom: "0.2rem", marginTop: "0.8rem" }}
            color={props.primary !== undefined && props.primary ? "primary" : "secondary"}>
            {props.text}
        </Typography>
    )
}